/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `0` - off
 * * `1` - higher order scheme (might be sensitive to instabilities)
 * * `2` - cross-sections treated as upwind method volume/surface area
 * * `3` - combination traditional method thin layer approach
 * @export
 */
export const LimiterSlopeCrossectionalArea2dEnum = {
  OFF: 0,
  HIGHER_ORDER_SCHEME__MIGHT_BE_SENSITIVE_TO_INSTABILITIES_: 1,
  CROSS_SECTIONS_TREATED_AS_UPWIND_METHOD_VOLUME_SURFACE_AREA: 2,
  COMBINATION_TRADITIONAL_METHOD_THIN_LAYER_APPROACH: 3,
} as const;
export type LimiterSlopeCrossectionalArea2dEnum =
  (typeof LimiterSlopeCrossectionalArea2dEnum)[keyof typeof LimiterSlopeCrossectionalArea2dEnum];

export function instanceOfLimiterSlopeCrossectionalArea2dEnum(value: any): boolean {
  for (const key in LimiterSlopeCrossectionalArea2dEnum) {
    if (Object.prototype.hasOwnProperty.call(LimiterSlopeCrossectionalArea2dEnum, key)) {
      if (
        LimiterSlopeCrossectionalArea2dEnum[
          key as keyof typeof LimiterSlopeCrossectionalArea2dEnum
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function LimiterSlopeCrossectionalArea2dEnumFromJSON(
  json: any
): LimiterSlopeCrossectionalArea2dEnum {
  return LimiterSlopeCrossectionalArea2dEnumFromJSONTyped(json, false);
}

export function LimiterSlopeCrossectionalArea2dEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): LimiterSlopeCrossectionalArea2dEnum {
  return json as LimiterSlopeCrossectionalArea2dEnum;
}

export function LimiterSlopeCrossectionalArea2dEnumToJSON(
  value?: LimiterSlopeCrossectionalArea2dEnum | null
): any {
  return value as any;
}

export function LimiterSlopeCrossectionalArea2dEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): LimiterSlopeCrossectionalArea2dEnum {
  return value as LimiterSlopeCrossectionalArea2dEnum;
}
